// Copy of components/transactionSearchResults/pagination.epic.js on its own Redux slice for the Payments - Beta tab.
import { ofType } from "redux-observable";
import * as RxOp from "rxjs/operators";

import { requestPaginatedSearch } from "@/components/transactionSearchPageV2Beta/TransactionSearchPageV2Beta.state";
import {
  PAGE_NEXT,
  PAGE_PREVIOUS,
  SET_CURRENT_PAGE,
  getCurrentPage,
  getIsClientPaginated,
} from "./TransactionSearchResultsV2Beta.state";

const SearchOnPageChangeEpic = (action$, state$) =>
  action$.pipe(
    ofType(PAGE_NEXT, PAGE_PREVIOUS, SET_CURRENT_PAGE),
    // A client-paged set already holds every row; re-requesting would re-fetch,
    // re-filter and reset to page 1.
    RxOp.filter(() => !getIsClientPaginated(state$.value)),
    RxOp.map(() => requestPaginatedSearch({ page: getCurrentPage(state$.value) })),
    RxOp.catchError((e) => console.error(e))
  );

export default SearchOnPageChangeEpic;
